class AddManyToManyReq {
    constructor(){
        this.Id1 = undefined;
        this.Id2 = undefined;
        this.QuantityNeeded = undefined;
        this.pagingParams = {
            pageNumber : undefined,
            pageSize : undefined
        }
    }
}

export default AddManyToManyReq;